import React from "react";
import styled from "styled-components";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

//
import TEAMIMG from "../../../assets/images/about-us-right.jpg";
import Button from "../../../components/button/Button";

export default function AboutClinic() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    easing: "",
  };

  const { t } = useTranslation();
  const navigate = useNavigate();

  function handleNavigate(url) {
    navigate(url);
  }

  return (
    <StyledAboutClinic>
      <div className="aboutClinic__img">
        <Slider {...settings}>
          <div>
            <img src={TEAMIMG} alt="TEAMIMG" />
          </div>
          <div>
            <img src={TEAMIMG} alt="TEAMIMG" />
          </div>
          <div>
            <img src={TEAMIMG} alt="TEAMIMG" />
          </div>
        </Slider>
      </div>
      <div className="container">
        <div className="aboutClinic__wrap">
          <div className="aboutClinic__left"></div>
          <div className="aboutClinic__right">
            <b>{t("homeAboutUsTitle")}</b>
            <h1>{t("homeAboutUsSubTitle")}</h1>
            <p>{t("homeAboutUsText")}</p>
            <Button
              padding={[16, 36]}
              onClick={() => handleNavigate("/about/clinic")}
            >
              {t("homeAboutUsBtn")}
            </Button>
          </div>
        </div>
      </div>
    </StyledAboutClinic>
  );
}

const StyledAboutClinic = styled.section`
  position: relative;
  background-color: var(--white);


  .aboutClinic {
    &__img {
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      width: 50%;
      height: 100%;

      .slick-slider {
        line-height: 0;
        height: 100%;

        .slick-list {
          height: 100%;

          .slick-track {
            height: 100%;

            .slick-slide {
              height: 100%;

              div {
                height: 100%;
              }
            }
          }
        }
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__wrap {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    &__left {
    }

    &__right {
      padding: 80px 0 60px 60px;

      b {
        color: var(--light-blue);
        font-size: var(--fs-subtitle);
        font-style: normal;
        font-weight: var(--fw-medium);
        line-height: var(--lh-subtitle);
      }

      h1 {
        color: var(--title);
        font-size: var(--fs-section-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
        margin: var(--space-title-subtitle) 0 var(--space-heading-body);
      }

      p {
        color: var(--text-2);
        font-size: var(--fs-body);
        font-style: normal;
        font-weight: var(--fw-regular);
        line-height: var(--lh-body);
        margin-bottom: 32px;
        text-align: left;
      }
    }
  }
`;
